export const objectKeys = (obj: Record<string, any>): string[] =>
  Object.keys(obj);
